import { getBoostTAE } from '@boost/widget-integration-tae/lib';
import { Injectable } from 'framework/di';

import type { PlatformRouter } from '../platform.interface';

@Injectable
export class ShopifyRouter implements PlatformRouter {
  get TAE() {
    return getBoostTAE();
  }

  get TAEConfig() {
    return this.TAE.config;
  }

  get page() {
    const page = this.TAEConfig?.generalSettings?.page;
    if (page === 'index') return 'home';
    if (page === 'cart') return 'cart';
    if (page === 'collection') return 'collection';
    if (page === 'product') return 'product';
    if (page === 'search') return 'search';
    if (window.location.pathname.indexOf('/collections/types') > -1) return 'vendor';
    if (window.location.pathname.indexOf('/collections/vendors') > -1) return 'types';
  }

  get routes() {
    return window.Shopify.routes;
  }
}
